import { render } from "./statistics.vue?vue&type=template&id=216b16ed&scoped=true"
import script from "./statistics.vue?vue&type=script&lang=js"
export * from "./statistics.vue?vue&type=script&lang=js"

import "./statistics.vue?vue&type=style&index=0&id=216b16ed&lang=scss&scoped=true"
import "./statistics.vue?vue&type=style&index=1&id=216b16ed&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-216b16ed"]])

export default __exports__